export default {
  'Start at': 'Начнется с',
  'Set to current time': 'Установить текущее время',
  'Audio volume': 'Громкость звука',
  'Video volume': 'Громкость видео',
  'Trim audio': 'Клип аудио',
  'Audio will end with the video': 'Аудио закончится с концом видео.',
  'Trim': 'Обрезать',
}